import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { CreateNavaidFromMapComponent } from 'src/app/footer/navaids/create-navaid-from-map/create-navaid-from-map.component';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { CoordinatePoint, CoordinatePointModel } from 'src/app/models/coordinate-point';
import { NavaidModel } from 'src/app/models/navaid';
import { Route } from 'src/app/models/Route';
import { SearchItem } from 'src/app/models/searchItem';
import { Segment } from 'src/app/models/Segment';
import { CreateProcedureFromRouteSegmentComponent } from 'src/app/popup/create-procedure-from-route-segment/create-procedure-from-route-segment.component';
import { GenericControlService } from 'src/app/popup/services/generic-control.service';
import { AirspaceBoundariesControlService } from 'src/app/services/airspace-boundaries-control.service';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidFromMapService } from 'src/app/services/navaid-from-map.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { PointsService } from 'src/app/services/points.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { ProjectService } from 'src/app/services/project.service';
import { RouteSegmentsService } from 'src/app/services/route-segments.service';
import { SearchService } from 'src/app/services/search.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { TrajectoryService } from 'src/app/services/trajectory.service';
import { MenuManagementService } from '../services/menu-management.service';
import { ProcedureAssessmentsService } from 'src/app/services/procedure-assessments.service';
import { DuplicationCheckOptionsComponent } from 'src/app/popup/duplication-check-options/duplication-check-options.component';
import { TabsService } from 'src/app/services/tabsService';
import { FeatureType } from 'src/app/models/EnumTypes';
import { CoordPointDuplicationCheckComponent } from 'src/app/popup/coord-point-duplication-check/coord-point-duplication-check.component';
import { DuplicationCheckComponent } from 'src/app/popup/duplication-check/duplication-check.component';
import { SaamTrafficService } from 'src/app/services/saamtrafficservice';
import { HttpClient } from '@angular/common/http';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ImportFileType } from 'src/app/models/ImportFileType';
import { ProcedureModel } from 'src/app/models/procedure';
import { SatPopover } from '@ncstate/sat-popover';
import { Geometry, LineString } from 'ol/geom';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { Observable } from 'rxjs/internal/Observable';
import { protobufPipe } from 'src/app/utils/pipes/protobufPipe';

//import { TabsService } from 'src/app/services/tabsService';

//#region GRIT
import {GritInterferenceTestDeviceService} from "../../services/grit/grit.interference-test-device.service";
import {GritRadarService} from "../../services/grit/grit.radar.service";
import {GritUserRoleGroup, GritUserService} from "../../services/grit/grit.user.service";
//endregion

@Component({
  selector: 'app-database-menu',
  templateUrl: './database-menu.component.html',
  styleUrls: ['./database-menu.component.scss'],
  standalone: false
})
export class DatabaseMenuComponent implements OnInit {

  protected readonly TabsService = TabsService;

  constructor(public menuService: MenuManagementService,
     public navaidController : NavaidsService,
     public coordinatePointsController: CoordinatePointsService,
     public genericController : GenericControlService,
     private searchService : SearchService,
     public procedureController : ProcedureControlService,
     public airspaceBoundariesController : AirspaceBoundariesControlService,
     public trajectoryController : TrajectoryService,
     private navaidFromMapController : NavaidFromMapService,
     private toolsService : ToolsControlService,
     private popupService : BsModalService,
     private pointsController : PointsService,
     private routesService : RouteSegmentsService,
     public procedureAssessmentsController : ProcedureAssessmentsService,
     private modalService : ModalControlService,
     protected tabsService:TabsService,
     private modalServiceRef : BsModalService,
     public saamService: SaamTrafficService,
     public pointsService: PointsService,
     public projectService: ProjectService,
     public http: HttpClient,
     public uiBlock: UiBlockService,
      //#region GRIT
      public deviceService: GritInterferenceTestDeviceService,
      public radarService: GritRadarService,
      public gritUserService: GritUserService,
      //endregion
    public endpointService: EndpointsService,
     public readonly configurationService: ConfigurationService
  ) {

     }

  ngOnInit(): void {
  }

  createProcedureFromFile(event) : void {
      let target = event.target || event.srcElement;
      if (this.projectService.projectEditable()){
        this.uploadCPXMLAndOpenProcedureCreation(target.files[0]);
      }
      target.value = '';

  }
  public uploadCPXMLAndOpenProcedureCreation(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock(`Parsing XML file...`);
    this.http
      .post(
        this.endpointService.endpointParseImportFileCoordinatePoints + '/' + ImportFileType.COORDINATE_POINTS_XML,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe({
        next: (points: CoordinatePointModel[]) => {
        this.uiBlock.stopBlock();
        if (!points || points.length == 0){
          this.modalService.showMesssageModal(
            'Error importing',
            "No available Coordinate Points in file. Please make sure you are importing the correct XML file."
          );
          return;
        }
        let newProcedure : ProcedureModel = new ProcedureModel();
        newProcedure.procedureCoordinatePoints = this.procedureController.createProcedureCoordinatePointsFromCoordinatePoints(points);
        newProcedure.procedureLegs = this.procedureController.createProcedureLegsFromProcedure(newProcedure);
        this.tabsService.openNewCreateTab(TabsService.CREATE_PROCEDURE_CP_FILE, newProcedure);
      },
      error: (error) => {
            this.uiBlock.stopBlock();
            this.pointsController.handleImportError(error, "XML");
          }
        });
  }
  createAirSpaceBoundaryFromFile() : void {
    let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
    element.click();
  }
  createProcedureFromSelectedZone(){
    this.tabsService.openNewOpenNewCreateProcedureFromSelectedZoneTab();
  }
  createProcedureFromRouteSegment() : void {
    if (!this.projectService.projectEditable()){
      return;
    }
    let routeSegments : Map<String,Route> = new Map();
    let selectedRouteSegments : Feature[] = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.RouteSegments).sort((a,b) => a.get("featureId") - b.get("featureId"));
    selectedRouteSegments = this.removeDuplicatedFeaturesByGeometry(selectedRouteSegments);
    selectedRouteSegments.forEach(feature => {
      let newSegment: Segment = this.routesService.transformFeatureInSegment(feature, feature.get('pointsProjection'));
      if(!routeSegments.get(newSegment.routeDesignation)){
        let newRoute : Route = new Route();
        newRoute.designation = newSegment.routeDesignation;
        newRoute.segments.push(newSegment);
        routeSegments.set(newSegment.routeDesignation, newRoute);
      } else {
        let route : Route = routeSegments.get(newSegment.routeDesignation);
        route.segments.push(newSegment);
      }
    });
    let continuityErrorOneRoute : boolean = false;
    routeSegments.forEach((value: Route, key: string) => {
      this.routesService.calculateRouteSegmentsContinuity(value);
      if(routeSegments.size == 1 && !value.continuous){
        continuityErrorOneRoute = true;
        this.modalService.showMesssageModal("Create Procedure from Route Segments","None of the routes corresponding to the selected segments are continuous, please redo the selection.");
        return;
      }
    });

    if (routeSegments.size > 0){
      if(!continuityErrorOneRoute){
        const bsModalRef : BsModalRef = this.popupService.show(CreateProcedureFromRouteSegmentComponent, {
          backdrop: 'static' // Prevent closing on backdrop click
        });
        bsModalRef.content.routeSegments = routeSegments;
      }
    } else {
      this.modalService.showMesssageModal("Create Procedure from Route Segments","Select at least one route segment.");
    }

  }

  private removeDuplicatedFeaturesByGeometry(featuresList: Feature<Geometry>[]) {
    if (featuresList == null || featuresList.length == 0) {
      return featuresList;
    }
    const uniqueGeometries = new Set();
    return featuresList.filter(feat => {
      const geometry = feat.getGeometry();

      if (geometry instanceof LineString) {
        // Transform and round each coordinate to 5 decimal places
        const roundedCoordinates = geometry.getCoordinates().map(coord =>
          [parseFloat(Number(coord[0]).toFixed(5)), parseFloat(Number(coord[1]).toFixed(5))]
        );

        const geometryString = JSON.stringify(roundedCoordinates);

        if (uniqueGeometries.has(geometryString)) {
          return false; // Filter out duplicate
        } else {
          uniqueGeometries.add(geometryString); // Track unique geometry
          return true;
        }
      }

      // if feature is not a linestring it will not be included in the final list
      return false;
    });

  }

  openNewProcedureAssessment(){
    this.tabsService.openNewProcedureAssessment();
  }

  openCoordinatePointsDuplicationCheckAll(): void {
    this.http.get<ArrayBuffer>(
      this.endpointService.apiUrlCoordinatePoints, {
        ...this.endpointService.httpOptions,
        responseType: "arraybuffer" as "json", // Receive binary data
      }).pipe(protobufPipe<CoordinatePointModel>(CoordinatePointModel)).subscribe((coordinatePoints) =>
        CoordPointDuplicationCheckComponent.showDuplicates(coordinatePoints, this.modalServiceRef, this.modalService)
    );
  }

  openCoordinatePointsDuplicationCheckSelected(){
    let coordPoint = this.pointsController.getSelectedCoordinatePoints();
    CoordPointDuplicationCheckComponent.showDuplicates(coordPoint, this.modalServiceRef, this.modalService);
  }

  openDuplicationCheckOptions(){
    this.popupService.show(DuplicationCheckOptionsComponent);
  }
  navaidDuplicationChecksAll(){
    let navaidsToCheck = this.pointsController.getAllNavaidsFromLayers()
    DuplicationCheckComponent.showDuplicates(navaidsToCheck,this.popupService,this.modalService);
  }
  navaidDuplicationsChecksSelected(){
    let navaidsToCheck = this.pointsController.getSelectedNavaids();
    DuplicationCheckComponent.showDuplicates(navaidsToCheck,this.popupService,this.modalService);
  }
  createNavaid(){
    this.tabsService.openNewCreateTab(TabsService.CREATE_NAVAID_TYPE);
  }
  editNavaid(){
    this.tabsService.openNewEditNavaidTab();
  }
  editProcedure(){
    this.tabsService.openNewEditProcedureTab()
  }
  createProcedure(){
    this.tabsService.openNewCreateTab(TabsService.CREATE_PROCEDURE);
  }
  procedureNavaidAssociation(){
    let procedure_features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Procedure);
    let navaid_features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    if (procedure_features.length > 0 && navaid_features.length > 0){
      this.modalService.showMesssageModal("Procedure Navaid Association", "Please select only Navaids or only Procedures.");
      return;
    }
    if( procedure_features.length > 0 || navaid_features.length > 0){
      this.tabsService.openNewProcedureNavaidsAssociation();
    }else {
      this.modalService.showMesssageModal("Procedure Navaid Association", "Please select Navaids or Procedures.");
    }

  }
  createCoordinatePoint(){
    this.tabsService.openNewCreateTab(TabsService.CREATE_COORDINATE_POINTS);
  }
  editCP() {
    this.tabsService.openNewEditCP();
  }
  createAirspaceBoundary(){
    this.tabsService.openNewCreateTab(TabsService.CREATE_AIRSPACE_BOUNDARIES);
  }
  createAirSpaceBoundaryFromSelectedVertices(){
    this.tabsService.openNewAirSpaceBoundariesFromSelectedVerticesTab()
  }
  createNavaidFromMap(): void{
    this.tabsService.openNewCreateTab(TabsService.CREATE_NAVAID_FROM_MAP);
  }
  editAirspaceBoundary(){
    this.tabsService.openNewEditAirspaceBoundary();
  }
  createCPWithAzimuthAndDistance(){
    this.tabsService.openCreateCPFromCoords(true);
  }
  createCPFromNavaid(){
    this.tabsService.openCreateCPFromCoords(false);
  }
  deleteTrajectory():void {

  }

  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
